import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Megaphone } from 'lucide-react';
import { Linkified } from './TeamChat';

const API = process.env.REACT_APP_BACKEND_URL;

// Organizer: post one message into every team's chat
export const CompanyBroadcastPanel = ({ eventId, headers }) => {
  const [text, setText] = useState('');
  const [list, setList] = useState([]);
  const [busy, setBusy] = useState(false);
  const load = () => axios.get(`${API}/api/event-teams/company/${eventId}/broadcasts`, { headers }).then((r) => setList(r.data.broadcasts || [])).catch(() => {});
  useEffect(() => { load(); }, [eventId]);
  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try { const r = await axios.post(`${API}/api/event-teams/company/${eventId}/broadcast`, { text }, { headers }); toast.success(r.data.message); setText(''); load(); }
    catch (e) { toast.error(e.response?.data?.detail || 'Broadcast failed'); }
    finally { setBusy(false); }
  };
  return (
    <div className="space-y-4" data-testid="company-broadcast-panel">
      <div className="bg-white border border-gray-200 rounded-xl p-4 space-y-3">
        <p className="text-sm font-semibold text-[#191919] flex items-center gap-2"><Megaphone size={16} className="text-amber-500" /> Message every team</p>
        <textarea rows={3} value={text} onChange={(e) => setText(e.target.value)} maxLength={2000} placeholder="e.g. Submissions close at 6 PM. Join the closing ceremony: https://meet..."
          className="w-full px-3 py-2 border border-gray-300 rounded-lg text-sm text-[#191919] focus:outline-none focus:border-[#0a66c2]" data-testid="broadcast-input" />
        <div className="flex justify-end">
          <button onClick={send} disabled={busy || !text.trim()} className="px-4 py-2 bg-[#0a66c2] hover:bg-[#004182] text-white rounded-lg text-sm font-medium disabled:opacity-50" data-testid="broadcast-send-btn">{busy ? 'Sending…' : 'Send to all teams'}</button>
        </div>
      </div>
      <div className="bg-white border border-gray-200 rounded-xl divide-y divide-gray-100" data-testid="broadcast-history">
        {list.length === 0 ? <p className="text-sm text-[#666] text-center py-8">No broadcasts yet</p> : list.map((b) => (
          <div key={b.id} className="px-4 py-3" data-testid={`broadcast-row-${b.id}`}>
            <p className="text-sm text-[#191919] whitespace-pre-wrap"><Linkified text={b.text} /></p>
            <p className="text-xs text-[#666] mt-1">{new Date(b.created_at).toLocaleString()}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
